import { Skeleton } from '@shared/components/shadcn';
import type { LotteryName } from '../../lottery-purchases/types';
import { TablePrimaryHeader } from '../components/PrizeTables/components/TablePrimaryHeader/TablePrimaryHeader';

type PrizeTablesSkeletonProps = {
  lotteryName: LotteryName;
};

function PrizeTablesSkeleton({ lotteryName }: PrizeTablesSkeletonProps) {
  return (
    <div className="flex flex-col gap-8" data-testid="prize-tables-skeleton">
      <TablePrimaryHeader namespace={`lotteries.${lotteryName}`} />
      <div className="md:hidden space-y-4">
        {Array.from({ length: 6 }, (_, index) => (
          <div key={index} className={`p-4 rounded-lg border border-gray-200 shadow-sm ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <Skeleton className="h-4 w-8" />
                <Skeleton className="h-5 w-3" />
              </div>
              <div className="flex justify-between items-center">
                <Skeleton className="h-4 w-12" />
                <Skeleton className="h-4 w-20" />
              </div>
              <div className="flex justify-between items-center">
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="hidden md:block bg-white rounded-lg overflow-hidden border border-gray-200 shadow-sm">
        <div className="bg-gray-50 p-4 border-b border-gray-200">
          <div className="grid grid-cols-4 gap-4">
            <Skeleton className="h-4 w-8" />
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-16" />
          </div>
        </div>
        {Array.from({ length: 6 }, (_, index) => (
          <div key={index} className="p-4 border-b border-gray-200 last:border-b-0">
            <div className="grid grid-cols-4 gap-4 items-center">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-15" />
              <Skeleton className="h-4 w-10" />
              <Skeleton className="h-4 w-18" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { PrizeTablesSkeleton, type PrizeTablesSkeletonProps };
